import { memo, useRef } from 'react'

import Lottie, { LottieRefCurrentProps } from 'lottie-react'

import { MissionLocationIcon } from '@local/assets/icons'

import Image, { ImageProps } from '@web/components/Image'
import photoInfra from '@web/libs/media/photoInfra'
import { useRegistToSequentialList } from '@web/libs/sequential'
import { Nullish } from '@web/types'

import GaugeLottie from '../../modal/lottie/Place_ReviewGauge.json'
import styles from '../MissionCard/Content/ProgressStamp/ProgressStamp.module.scss'

interface Props {
  total: number
  count: number
  number: number
  image?: Nullish<ImageProps['src']>
  order?: number
}

const SEGMENT_STEP = 120

const CircleAnimationStamp = ({ total, count, image, number, order = 1 }: Props) => {
  const startSegment = Math.max(count - 1, 0) * SEGMENT_STEP
  const endSegment = startSegment + SEGMENT_STEP

  const lottieRef = useRef<LottieRefCurrentProps>(null)

  useRegistToSequentialList({
    order,
    onExecute: () => {
      lottieRef.current?.playSegments([startSegment, endSegment], true)
    },
    type: 'afterPrev',
    delaySeconds: 0,
    durationSeconds: 2,
    id: `circle-${order}`,
  })

  return (
    <div className={styles.circle_area}>
      <div className={styles.number}>{number + 1}</div>
      <>
        {image ? (
          <div className={styles.icon_area}>
            <Image
              className={styles.img}
              src={image}
              width="100%"
              height="100%"
              alt="리뷰"
              thumbnailType={photoInfra.type.f220_220_70_sharpen}
            />
          </div>
        ) : (
          <div className={styles.default_image_area}>
            <MissionLocationIcon className={styles.icon_location} aria-hidden="true" />
          </div>
        )}
        <Lottie
          lottieRef={lottieRef}
          autoplay={false}
          loop={false}
          className={styles.lottie_gauge}
          style={{
            width: 80,
            height: 80,
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
          initialSegment={[startSegment, startSegment]}
          animationData={GaugeLottie}
        />
      </>
    </div>
  )
}

export default memo(CircleAnimationStamp)
